// IE 2026 09 18 / ODOO-… (замечание Игоря: «текст, который показывается поверх текущей ячейки, чуть сдвинут вниз — ожидаю,
// что не будет мельканий и та часть текста, которая поверх, будет пиксель в пиксель; то же в других элементах»).
// «Бесшовное продолжение» обрезанного текста — общий помощник для ячеек / заголовков грида и строк форм чипсов.
// Главное правило: там, где элемент показывает свой текст САМ, оверлея НЕТ — он начинается у места обрезки (за букву до
// многоточия) и несёт только «хвост». Часть текста над элементом — это сам элемент, поэтому совпадение с ним гарантировано
// по построению, а всё, что нарисовано на ячейке (рамка выделения, бейджи, подсветки, значки), остаётся на виду.
// Элемент закрывается целиком только когда хвост невозможен: перенос строк либо свой текст (округлённая длительность).
// Оверлей повторяет сам элемент: тот же фон (с учётом прозрачности и градиента), тот же цвет и параметры шрифта, то же
// оформление вложенных элементов (подчёркнутая ссылка, подсветка найденного), рамка — тенью, а не border'ом (border сдвигал
// бы содержимое). Положение текста не вычисляется, а ИЗМЕРЯЕТСЯ: первая буква элемента и первая буква оверлея замеряются
// Range'ем (дробные px), разница гасится смещением содержимого — поэтому совпадение не зависит от отступов, выравнивания,
// высоты строки и способа вертикальной раскладки исходного элемента.

// служебные элементы — не текст: в оверлей не переносятся, первую букву среди них не ищем
import { overlayRoot } from './overlayRoot'   // IE 2026 09 23 / ODOO-… (замечание Игоря: панели-меню в Full screen): в полноэкране виджета оверлей внутри виджета
import { cellPeek_clipPath } from './cellPeek'   // IE 2026 11 04 / ODOO-350449 (замечание Игоря: продолжение ячейки при наведении — только при обрезке и не поверх содержимого): «окна» подложки над слоями ячейки

const SKIP = 'button, input, select, textarea, i, svg, img, canvas, .pi, .cell-dropdown-toggle, .wj-elem-collapse, .wj-btn, .break-arrow, .chip-open-ico, [class*="wj-glyph"]'
// параметры, от которых зависит растеризация и раскладка текста
const TEXT_PROPS = ['fontFamily', 'fontSize', 'fontWeight', 'fontStyle', 'fontStretch', 'fontVariantCaps', 'fontVariantNumeric', 'fontVariantLigatures',
    'fontKerning', 'fontFeatureSettings', 'fontVariationSettings', 'fontOpticalSizing', 'lineHeight', 'letterSpacing', 'wordSpacing',
    'textTransform', 'textRendering', 'webkitFontSmoothing', 'direction', 'tabSize', 'color', 'textShadow',
    'textDecorationLine', 'textDecorationStyle', 'textDecorationColor', 'textDecorationThickness', 'textUnderlineOffset']
// оформление вложенных элементов (ссылка, подсветка найденного, пилюля)
const BOX_PROPS = ['backgroundColor', 'borderRadius', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight',
    'borderLeftWidth', 'borderLeftStyle', 'borderLeftColor', 'borderRightWidth', 'borderRightStyle', 'borderRightColor',
    'borderTopWidth', 'borderTopStyle', 'borderTopColor', 'borderBottomWidth', 'borderBottomStyle', 'borderBottomColor',
    'verticalAlign', 'opacity', 'boxSizing']

// список теней computed box-shadow → по одной (запятые внутри rgb() не разделители)
function splitShadows(v) {
    if (!v || v === 'none') return []
    const out = []; let depth = 0, cur = ''
    for (const ch of v) {
        if (ch === '(') depth++
        else if (ch === ')') depth--
        if (ch === ',' && !depth) { out.push(cur.trim()); cur = '' } else cur += ch
    }
    if (cur.trim()) out.push(cur.trim())
    return out
}

// текст элемента рисуется серым (не LCD) сглаживанием: его слой — всплывающий блок (position: fixed / transform / will-change)
// с внешней тенью, скруглением с рамкой или непрозрачностью. Эффекты самого элемента (filter, opacity) оверлей копирует сам
function grayTextLayer(el) {
    for (let p = el; p && p.nodeType === 1 && p !== document.body; p = p.parentElement) {
        const cs = getComputedStyle(p)
        const layerRoot = cs.position === 'fixed' || cs.transform !== 'none' || /transform|opacity|filter/.test(cs.willChange || '')
        if (!layerRoot) continue
        const outer = splitShadows(cs.boxShadow).some(x => !/\binset\b/.test(x))
        const bgc = parseColor(cs.backgroundColor)
        return outer || !bgc || bgc[3] < 1 || (parseFloat(cs.borderTopLeftRadius) || 0) > 0 || (parseFloat(cs.borderTopRightRadius) || 0) > 0
    }
    return false
}

function hiddenEl(el, cs) {
    return cs.display === 'none' || cs.visibility === 'hidden' || cs.position === 'absolute' || cs.position === 'fixed'
}

// первая видимая буква: {node, offset} среди текстовых узлов вне служебных и скрытых элементов
function firstGlyph(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT)
    let tn
    while ((tn = walker.nextNode())) {
        const off = tn.textContent.search(/\S/)
        if (off < 0) continue
        let p = tn.parentElement, skip = false
        while (p && p !== root) {
            if (p.matches(SKIP) || hiddenEl(p, getComputedStyle(p))) { skip = true; break }
            p = p.parentElement
        }
        if (!skip) return { node: tn, offset: off }
    }
    return null
}

// прямоугольники видимых букв по порядку (не более limit): [{r, node, offset}]
function glyphRects(root, limit = 600) {
    const out = []
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT)
    let tn
    while ((tn = walker.nextNode())) {
        let p = tn.parentElement, skip = false
        while (p && p !== root) {
            if (p.matches(SKIP) || hiddenEl(p, getComputedStyle(p))) { skip = true; break }
            p = p.parentElement
        }
        if (skip) continue
        const t = tn.textContent
        for (let i = 0; i < t.length; i++) {
            let r = null, n = 0
            try { const rng = document.createRange(); rng.setStart(tn, i); rng.setEnd(tn, i + 1); r = rng.getBoundingClientRect(); n = rng.getClientRects().length } catch (e) { r = null }
            if (r && (r.width || r.height)) out.push({ r, n, node: tn, offset: i })
            if (out.length >= limit) return out
        }
    }
    return out
}

let _ellCanvas = null
function ellipsisWidth(cs) {
    try {
        _ellCanvas = _ellCanvas || document.createElement('canvas')
        const ctx = _ellCanvas.getContext('2d')
        ctx.font = `${cs.fontStyle} ${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`
        return ctx.measureText('\u2026').width + (parseFloat(cs.letterSpacing) || 0)
    } catch (e) { return (parseFloat(cs.fontSize) || 12) * 0.8 }
}

// место, с которого элемент перестаёт показывать свой текст: x начала «хвоста». null — хвост невозможен (перенос строк)
function cutPoint(el) {
    const g = firstGlyph(el)
    if (!g) return null
    // кто режет текст: ближайший к тексту предок (до самого элемента) с обрезкой по ширине
    let ce = null
    for (let p = g.node.parentElement; p; p = p.parentElement) {
        const s = getComputedStyle(p)
        if (/hidden|clip/.test(s.overflowX) && p.scrollWidth > p.clientWidth) { ce = p; break }
        if (p === el) break
    }
    ce = ce || el
    const s = getComputedStyle(ce)
    if (!/nowrap|^pre$/.test(s.whiteSpace)) return null
    const r = ce.getBoundingClientRect()
    const clipRight = r.right - (parseFloat(s.borderRightWidth) || 0)   // край обрезки — по внутреннему полю (padding box)
    const gl = glyphRects(el)
    if (!gl.length) return null
    const line = gl[0].r
    for (const q of gl) if (Math.abs(q.r.top - line.top) > line.height / 2) return null   // вторая строка — текст перенесён
    // Chrome сам говорит, какие буквы показаны при многоточии: у них два прямоугольника (усечённый фрагмент строки + скрытый
    // полный), у спрятанных — один
    let last = -1, signal = false
    for (let i = 0; i < gl.length; i++) if (gl[i].n >= 2) { last = i; signal = true }
    // обрезка без многоточия (в т.ч. text-overflow: ellipsis у flex / grid-контейнера — там браузер его не рисует):
    // хвост — от края обрезки, хоть посреди буквы
    if (!signal && (!/ellipsis/.test(s.textOverflow) || /flex|grid/.test(s.display))) return { x: clipRight }
    // многоточие: хвост начинается сразу за последней ПОКАЗАННОЙ буквой — ни одной буквы элемента оверлей не перерисовывает.
    // Нет признака Chrome — считаем, как браузер: буква показана, если целиком умещается до места многоточия
    // (с перестраховкой в сторону «спрятана»: лишняя буква в хвосте безвредна, потерянная — нет)
    if (!signal) {
        const limit = clipRight - (parseFloat(s.paddingRight) || 0) - ellipsisWidth(s) - 0.02
        for (let i = 0; i < gl.length; i++) { if (gl[i].r.right <= limit) last = i; else break }
    }
    return { x: last >= 0 ? gl[last].r.right : gl[0].r.left }
}

// IE 2026 11 03 / ODOO-350449 (заказ Игоря: p224 заголовок виджета — «…» и продолжение по наведению, как в ячейках): поле ввода (заголовок виджета) — текст в value, текстовых узлов нет: место обрезки считается по ширинам префиксов
// (холст тем же шрифтом), как браузер режет при многоточии — буква показана, если целиком умещается до места «…».
// Чистая часть — для юнит-теста: start — x первой буквы, limit — правее него буквы не показаны, prefixWidths[i] — ширина первых i+1 букв
export function textCut_x(start, limit, prefixWidths) {
    let x = start
    for (const w of prefixWidths || []) { if (start + w <= limit) x = start + w; else break }
    return x
}
function isTextInput(el) { return el?.tagName === 'INPUT' }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p224 заголовок виджета — «…» и продолжение по наведению, как в ячейках)
// x первой буквы поля: левый край + рамка + поле − прокрутка
function inputStart(el, cs, rr) { return rr.left + (parseFloat(cs.borderLeftWidth) || 0) + (parseFloat(cs.paddingLeft) || 0) - (el.scrollLeft || 0) }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p224 заголовок виджета — «…» и продолжение по наведению, как в ячейках)
// место обрезки поля; null — текст помещается
function inputCutPoint(el, cs, rr) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p224 заголовок виджета — «…» и продолжение по наведению, как в ячейках)
    const v = String(el.value || '')
    if (!v || !(el.scrollWidth > el.clientWidth + 1)) return null
    const clipRight = rr.right - (parseFloat(cs.borderRightWidth) || 0)
    if (!/ellipsis/.test(cs.textOverflow) || document.activeElement === el) return { x: clipRight }   // без многоточия (в правке) — хвост от края обрезки
    const limit = clipRight - (parseFloat(cs.paddingRight) || 0) - ellipsisWidth(cs) - 0.02
    const ls = parseFloat(cs.letterSpacing) || 0
    const widths = [], start = inputStart(el, cs, rr)
    try {
        _ellCanvas = _ellCanvas || document.createElement('canvas')
        const ctx = _ellCanvas.getContext('2d')
        ctx.font = `${cs.fontStyle} ${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`
        const chars = Array.from(v)
        let acc = ''
        for (let i = 0; i < chars.length; i++) { acc += chars[i]; widths.push(ctx.measureText(acc).width + ls * (i + 1)); if (start + widths[i] > limit) break }
    } catch (e) { return { x: clipRight } }
    return { x: textCut_x(start, limit, widths) }
}

function glyphRect(g) {
    if (!g) return null
    try {
        const rng = document.createRange()
        rng.setStart(g.node, g.offset)
        rng.setEnd(g.node, g.offset + 1)
        const r = rng.getBoundingClientRect()
        return (r && (r.width || r.height)) ? r : null
    } catch (e) { return null }
}

function parseColor(c) {
    const m = /rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:[,/\s]+([\d.]+%?))?\s*\)/.exec(c || '')
    if (!m) return null
    let a = m[4] === undefined ? 1 : (String(m[4]).endsWith('%') ? parseFloat(m[4]) / 100 : parseFloat(m[4]))
    if (!(a >= 0)) a = 1
    return [+m[1], +m[2], +m[3], a]
}

// фон элемента так, как его видит пользователь: полупрозрачные слои предков складываются до первого непрозрачного
function resolvedBackground(el) {
    const layers = []
    let p = el
    while (p && p.nodeType === 1) {
        const c = parseColor(getComputedStyle(p).backgroundColor)
        if (c && c[3] > 0) {
            layers.push(c)
            if (c[3] >= 1) break
        }
        p = p.parentElement
    }
    let out = [255, 255, 255]
    for (let i = layers.length - 1; i >= 0; i--) {
        const [r, g, b, a] = layers[i]
        out = [r * a + out[0] * (1 - a), g * a + out[1] * (1 - a), b * a + out[2] * (1 - a)]
    }
    return `rgb(${Math.round(out[0])}, ${Math.round(out[1])}, ${Math.round(out[2])})`
}

function copyProps(from, to, props) {
    for (const p of props) {
        try { const v = from[p]; if (v !== undefined && v !== '') to[p] = v } catch (e) { /* свойство не поддержано */ }
    }
}

// содержимое элемента без служебных узлов; оформление вложенных элементов — inline (классы вне своего контейнера не действуют)
function cloneContent(src, dst) {
    for (const n of src.childNodes) {
        if (n.nodeType === 3) { dst.appendChild(document.createTextNode(n.textContent)); continue }
        if (n.nodeType !== 1 || n.matches(SKIP)) continue
        const cs = getComputedStyle(n)
        if (hiddenEl(n, cs)) continue
        const el = document.createElement('span')
        copyProps(cs, el.style, TEXT_PROPS)
        copyProps(cs, el.style, BOX_PROPS)
        // блочные обёртки текста (.cell-text-clip и т.п.) в строке оверлея — строчные блоки: обрезка и ширина не переносятся
        el.style.display = /^inline/.test(cs.display) ? cs.display : (cs.display === 'contents' ? 'contents' : 'inline-block')
        el.style.whiteSpace = 'nowrap'
        cloneContent(n, el)
        dst.appendChild(el)
    }
}

/**
 * Показать «продолжение» обрезанного текста элемента el поверх него.
 *   text      — свой текст вместо содержимого элемента (округлённая длительность: показано «2m», полный «2.1m»);
 *   className — класс оверлея (оформление рамки / слоя — в CSS владельца);
 *   padRight  — поле справа от текста;
 *   clipX     — правее этого x текст элемента не виден (его накрывает другой слой, напр. панель кнопок шапки): хвост — не правее него
 *               (IE 2026 11 03 / ODOO-350449 (заказ Игоря: p224 заголовок виджета — «…» и продолжение по наведению, как в ячейках)).
 *   keep      — прямоугольники слоёв элемента (капсулы, SVG, абсолютные элементы), которые оверлей не должен закрывать: в подложке над ними —
 *               «окна», под окном видна сама ячейка (IE 2026 11 04 / ODOO-350449 (замечание Игоря: продолжение ячейки при наведении — только при обрезке и не поверх содержимого)).
 * Поле ввода (input) — текст из value (IE 2026 11 03 / ODOO-350449 (заказ Игоря: p224 заголовок виджета — «…» и продолжение по наведению, как в ячейках)).
 * Возвращает элемент оверлея (удаляет владелец) либо null.
 */
export function clipOverlay_show(el, { text = '', className = 'clip-overlay', padRight = 10, clipX = null, keep = null } = {}) {   // IE 2026 11 04 / ODOO-350449 (замечание Игоря: продолжение ячейки при наведении — только при обрезке и не поверх содержимого)
    if (!el?.isConnected) return null
    const rr = el.getBoundingClientRect()
    if (!rr.width || !rr.height) return null
    const cs = getComputedStyle(el)
    const inp = isTextInput(el)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p224 заголовок виджета — «…» и продолжение по наведению, как в ячейках)
    const g0 = inp ? null : firstGlyph(el)
    const r0 = inp ? { left: inputStart(el, cs, rr), top: null } : glyphRect(g0)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p224 заголовок виджета — «…» и продолжение по наведению, как в ячейках): верх буквы поля — по замеру оверлея (ниже)

    const ov = document.createElement('div')
    ov.className = className
    const inner = document.createElement('span')
    inner.className = 'clip-overlay-text'
    inner.style.cssText = 'position: relative; z-index: 1; display: inline-block; white-space: nowrap; flex: 0 0 auto;'
    if (text) inner.textContent = text
    else if (inp) inner.textContent = String(el.value || '')   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p224 заголовок виджета — «…» и продолжение по наведению, как в ячейках)
    else cloneContent(el, inner)
    ov.appendChild(inner)

    copyProps(cs, ov.style, TEXT_PROPS)
    ov.style.textDecorationLine = 'none'   // подчёркивание несут вложенные элементы; своё у контейнера дало бы двойную линию
    if (cs.textDecorationLine && cs.textDecorationLine !== 'none') inner.style.textDecorationLine = cs.textDecorationLine
    // подложка: фон — как у самого элемента (с градиентом полосы), чтобы часть поверх элемента не отличалась от него.
    // Отдельным внутренним блоком по ТОЧНОМУ (дробному) прямоугольнику элемента: сам слой встаёт на целые пиксели устройства
    // (см. ниже), а грид бывает сдвинут на долю пикселя — нижняя линия строки должна лечь туда же, где она у ячейки
    const bg = document.createElement('div')
    bg.className = 'clip-overlay-bg'
    bg.style.cssText = 'position: absolute; right: 0; box-sizing: border-box; pointer-events: none;'
    bg.style.backgroundColor = resolvedBackground(el)
    if (cs.backgroundImage && cs.backgroundImage !== 'none') {
        bg.style.backgroundImage = cs.backgroundImage
        bg.style.backgroundRepeat = cs.backgroundRepeat
        bg.style.backgroundPosition = cs.backgroundPosition
        bg.style.backgroundSize = cs.backgroundSize
    }
    // нижняя линия строки продолжается под текстом (у ячейки она входит в её высоту)
    const bb = parseFloat(cs.borderBottomWidth) || 0
    if (bb && cs.borderBottomStyle !== 'none') bg.style.borderBottom = `${cs.borderBottomWidth} ${cs.borderBottomStyle} ${cs.borderBottomColor}`
    ov.insertBefore(bg, inner)

    // «хвост»: оверлей начинается у места обрезки; часть текста над элементом рисует сам элемент
    let cut = text ? null : (inp ? inputCutPoint(el, cs, rr) : cutPoint(el))   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p224 заголовок виджета — «…» и продолжение по наведению, как в ячейках): поле ввода
    if (!text && clipX != null && clipX > rr.left && clipX < (cut ? cut.x : rr.right)) cut = { x: clipX }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p224 заголовок виджета — «…» и продолжение по наведению, как в ячейках): видимая часть кончается раньше (панель поверх)
    const tail = !!cut && cut.x > rr.left && cut.x < rr.right + 1
    // закрываем целиком (перенос строк / свой текст): пиктограмма перед текстом (папка ссылки, значок свёртки) остаётся
    // видимой — оверлей начинается у первой буквы
    const padL = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.borderLeftWidth) || 0)
    let left = rr.left, innerPad = padL
    if (tail) {
        left = cut.x
        innerPad = 0
        ov.style.overflow = 'hidden'
    } else if (r0 && r0.left - rr.left > padL + 2 && r0.left < rr.right) {
        left = Math.max(rr.left, r0.left - 3)
        innerPad = r0.left - left
    }
    // приглушённые строки (opacity у элемента или предков): текст оверлея — той же плотности
    let op = 1
    for (let p = el; p && p.nodeType === 1; p = p.parentElement) { const o = parseFloat(getComputedStyle(p).opacity); if (o >= 0 && o < 1) op *= o }
    if (op < 1) inner.style.opacity = String(op)
    // подсветка строки / заголовка под курсором — filter: brightness(96%) самой ячейки (и предков до корня приложения);
    // тёмная тема — filter: invert(1) на корне приложения: оверлей живёт в body вне его, цвета взяты «до фильтров».
    // Порядок как в дереве: сначала фильтр элемента, затем предков
    const filters = []
    for (let p = el; p && p.nodeType === 1 && p !== document.body; p = p.parentElement) {
        const f = getComputedStyle(p).filter
        if (f && f !== 'none') filters.push(f)
    }
    if (filters.length) ov.style.filter = filters.join(' ')
    // внутренние тени элемента (подсветка строки у ячеек с бейджем правки, линия наведения у заголовка) — под рамкой оверлея
    const inset = splitShadows(cs.boxShadow).filter(x => /\binset\b/.test(x))
    if (inset.length) bg.style.boxShadow = inset.join(', ')
    // слой ставится на целые пиксели УСТРОЙСТВА: у слоя с дробным смещением браузер выключает субпиксельное (LCD) сглаживание
    // текста — буквы поверх элемента отличались бы по краям; дробную часть забирает внутренний отступ (текст — по замеру ниже)
    const dpr = window.devicePixelRatio || 1
    const snapDown = v => Math.floor(v * dpr + 1e-4) / dpr, snapUp = v => Math.ceil(v * dpr - 1e-4) / dpr
    const left0 = left, top0 = snapDown(rr.top)
    left = snapDown(left)
    innerPad += left0 - left
    ov.style.left = left + 'px'
    ov.style.top = top0 + 'px'
    ov.style.height = (snapUp(rr.bottom) - top0) + 'px'
    if (!tail) ov.style.minWidth = Math.max(0, snapUp(rr.right) - left) + 'px'
    ov.style.paddingLeft = innerPad + 'px'
    // хвост: весь текст лежит в оверлее, начало уведено влево за его край (отрицательное поле — ширина слоя = ширина хвоста)
    if (tail && r0) inner.style.marginLeft = (r0.left - left) + 'px'
    bg.style.left = (left0 - left) + 'px'
    bg.style.top = (rr.top - top0) + 'px'
    bg.style.height = rr.height + 'px'
    ov.style.paddingRight = padRight + 'px'
    overlayRoot().appendChild(ov)   // IE 2026 09 23 / ODOO-… (замечание Игоря: панели-меню в Full screen)

    // замер: первая буква оверлея → на место первой буквы элемента (дробные px, обе оси)
    const r1 = glyphRect(firstGlyph(inner))
    if (r0 && r1) {
        // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p224 заголовок виджета — «…» и продолжение по наведению, как в ячейках): у поля буква стоит по центру его внутренней высоты (строка поля центрируется браузером)
        const top0 = r0.top != null ? r0.top : rr.top + (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.paddingTop) || 0)
            + ((rr.height - ['borderTopWidth', 'borderBottomWidth', 'paddingTop', 'paddingBottom'].reduce((a, k) => a + (parseFloat(cs[k]) || 0), 0)) - r1.height) / 2
        const dx = r0.left - r1.left, dy = top0 - r1.top
        if (dx) inner.style.left = dx + 'px'
        if (dy) inner.style.top = dy + 'px'
        if (dx > 0 && !tail) ov.style.paddingRight = (padRight + dx) + 'px'
    }
    // рамка и тень — ОТДЕЛЬНЫМ слоем под текстовым: внешняя тень на самом текстовом слое делает его «непрозрачным не
    // полностью», и браузер переводит текст слоя с субпиксельного (LCD) сглаживания на серое — буквы поверх элемента
    // переставали совпадать с буквами элемента по краям (замер пробы lcd_diag: box-shadow / filter выключают LCD,
    // outline и скругление — нет). Исключение — элемент, который САМ живёт в «несплошном» слое (всплывающая форма:
    // position: fixed + тень): его текст браузер рисует серым сглаживанием, и оверлею нужно то же — тень на текстовом слое
    // у хвоста рамки и тени слева нет — он выходит из-под текста элемента
    const noLeft = 'inset(-14px -14px -14px 0px)'
    ov.dataset.clipMode = tail ? 'tail' : 'cover'
    // слои элемента под подложкой не прячутся: «окна» по их прямоугольникам (внешний контур — с полями под тень, у хвоста слева без поля, как noLeft)   // IE 2026 11 04 / ODOO-350449 (замечание Игоря: продолжение ячейки при наведении — только при обрезке и не поверх содержимого)
    let holes = ''   // IE 2026 11 04 / ODOO-350449 (замечание Игоря: продолжение ячейки при наведении — только при обрезке и не поверх содержимого)
    if (keep && keep.length) { try { holes = cellPeek_clipPath(ov.getBoundingClientRect(), keep, { l: tail ? 0 : 14, t: 14, r: 14, b: 14 }) } catch (e) { holes = '' } if (holes) ov.dataset.clipHoles = String(keep.length) }   // IE 2026 11 04 / ODOO-350449 (замечание Игоря: продолжение ячейки при наведении — только при обрезке и не поверх содержимого)
    if (grayTextLayer(el)) { ov.classList.add('clip-overlay-gray'); if (holes) ov.style.clipPath = holes; else if (tail) ov.style.clipPath = noLeft; return ov }   // IE 2026 11 04 / ODOO-350449 (замечание Игоря: продолжение ячейки при наведении — только при обрезке и не поверх содержимого)
    if (holes) ov.style.clipPath = holes   // IE 2026 11 04 / ODOO-350449 (замечание Игоря: продолжение ячейки при наведении — только при обрезке и не поверх содержимого)
    const or = ov.getBoundingClientRect()
    const sh = document.createElement('div')
    sh.className = 'clip-overlay-shadow'
    sh.style.left = left0 + 'px'; sh.style.top = rr.top + 'px'; sh.style.width = (or.right - left0) + 'px'; sh.style.height = rr.height + 'px'
    if (tail) sh.style.clipPath = noLeft
    ov.parentNode.insertBefore(sh, ov)   // IE 2026 09 23 / ODOO-… (замечание Игоря: панели-меню в Full screen): тень — рядом с оверлеем
    const remove0 = ov.remove.bind(ov)
    ov.remove = () => { sh.remove(); remove0() }
    ov.dataset.clipMode = tail ? 'tail' : 'cover'
    return ov
}

// для проб: расхождение первой и k-й буквы элемента и его оверлея (px)
export function clipOverlay_delta(el, ov, k = 0) {
    const a = firstGlyph(el), b = firstGlyph(ov?.querySelector?.('.clip-overlay-text') || ov)
    if (!a || !b) return null
    const at = (g) => { const len = g.node.textContent.length; return glyphRect({ node: g.node, offset: Math.min(g.offset + k, len - 1) }) }
    const ra = at(a), rb = at(b)
    return (ra && rb) ? { dx: rb.left - ra.left, dy: rb.top - ra.top } : null
}

// диапазоны текстов внутри оверлея — чтобы повторить подсветку ячейки (CSS Custom Highlight API живёт на диапазонах исходного DOM)
export function clipOverlay_textRanges(ov, texts) {
    const out = []
    const root = ov?.querySelector?.('.clip-overlay-text') || ov
    if (!root || !texts?.length) return out
    for (const txt of texts) {
        if (!txt) continue
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT)
        let n
        while ((n = walker.nextNode())) {
            const i = (n.nodeValue || '').indexOf(txt)
            if (i < 0) continue
            const r = document.createRange()
            try { r.setStart(n, i); r.setEnd(n, i + txt.length); out.push(r) } catch (e) { /* узел изменился */ }
            break
        }
    }
    return out
}
